<template>
  <div>
    <div class="mine-box-title">资料修改</div>
    <div
        class="mine-li"
        style=""
    >
      <div class="updatalinfo-row-title">基本信息</div>
      <div class="flex-start">
        <div class="info-row-title">用户名:</div>
        <div class="info-row-desc">{{ formData.name }}</div>
      </div>
      <div class="flex-start">
        <div class="info-row-title">注册时间:</div>
        <div class="info-row-desc">{{ formData.create_time | timeFormatSimple }}</div>
      </div>
    </div>
    <div class="mine-li">
      <div class="updatalinfo-row-title">资料修改</div>
      <div class="flex-between" style="padding:20px 0;border-bottom:1px solid rgba(0, 0, 0, 0.06)">
        <div class="flex-start">
          <div class="info-row-title">用户名</div>
          <div class="info-row-desc">{{ formData.name }}</div>
        </div>
        <div class="flex-start">
          <!--          <div class="tishi">安全性高的密码可以使帐号更安全。建议您定期更换密码</div>-->
          <div class="eidt-btn" @click="onMineInfoEdit('/user-name')">修改</div>
        </div>
      </div>

      <div class="flex-between" style="padding:20px 0;border-bottom:1px solid rgba(0, 0, 0, 0.06)">
        <div class="flex-start">
          <div class="info-row-title">登录密码</div>
          <div class="info-row-desc">******</div>
        </div>
        <div class="flex-start">
          <div class="tishi">安全性高的密码可以使帐号更安全。建议您定期更换密码</div>
          <div class="eidt-btn" @click="onMineInfoEdit('/user-password')">修改</div>
        </div>
      </div>
      <div v-if="false" class="flex-between" style="padding:20px 0;border-bottom:1px solid rgba(0, 0, 0, 0.06)">
        <div class="flex-start">
          <div class="info-row-title">支付密码</div>
          <div class="info-row-desc">******</div>
        </div>
        <div class="flex-start">
          <div class="tishi"></div>
          <div class="eidt-btn" @click="onMineInfoEdit('/pay-password')">修改</div>
        </div>
      </div>
      <div class="flex-between" style="padding:20px 0;">
        <div class="flex-start">
          <div class="info-row-title">绑定手机</div>
          <div class="info-row-desc">{{ formData.phone }}</div>
        </div>
        <div class="flex-start">
          <div class="tishi">您的手机为安全手机，可以用于登录系统，也可以找回密码</div>
          <div class="eidt-btn" @click="onMineInfoEdit('/set-phone')">修改</div>
        </div>
      </div>
    </div>

    <div
        class="mine-li"
        style=""
    >
      <div class="updatalinfo-row-title">我的功能</div>
      <div class="func-row-box">
        <div class="func-row-li" v-for="item in funcList" :key="item.key" @click="toFunc(item)">
          <div class="func-row-img">
            <img :src="item.pic" alt="">
          </div>
          <div class="func-row-tip" v-html="item.name"></div>
        </div>

      </div>
    </div>

    <div>
      <el-form label-width="108px" :model="formData" ref="ruleForm" :rules="rules" v-if="false">
        <el-form-item label="用户名" prop="username">
          <el-input
              type="text"
              style="width: 600px"
              placeholder="请输入用户名"
              v-model="formData.username"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input
              type="password"
              style="width: 600px"
              v-model="formData.pass"
              autocomplete="off"
              placeholder="请输入密码"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="checkPass">
          <el-input
              type="password"
              style="width: 600px"
              v-model="formData.checkPass"
              autocomplete="off"
              placeholder="请输入密码"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
              placeholder="请输入中国大陆手机号"
              v-model.number="formData.phone"
              style="width: 600px"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
              placeholder="请输入验证码"
              v-model.number="formData.code"
              clearable
              style="width: 150px; height: 34px"
              class="inputidecode"
          ></el-input>
          <el-button @click="getidecodeFun">{{ getidecodeData }}</el-button>
        </el-form-item>
        <el-form-item class="el-foot-bar fixed-footer-bar">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">还原</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
    >
      <span>正在建设中~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "UpdateInfo",
  data() {

    return {
      centerDialogVisible: false,
      formData: {
        name: '',
        phone: '',
        create_time: ''
      },

      funcList: [
        {name: '赛事活动', pic: require("../../../assets/images/mine/icon-saishihuodong@2x.png"), key: "sai"},
        {name: "俱乐部<br>七彩星级", pic: require("../../../assets/images/mine/icon-julebu@2x.png"), key: "club"},
        {name: '培训会议', pic: require("../../../assets/images/mine/icon-huiyi@2x.png"), key: "huiyi"},
        {name: '大课间', pic: require("../../../assets/images/mine/icon-dakejian@2x.png"), key: "dakejian"},
        {name: '运动员等级', pic: require("../../../assets/images/mine/icon-sihaoyundongyaun@2x.png"), key: "sihao"},
      ]
    };
  },
  mounted() {
    document.title = '资料修改'
    this.getUser();
  },
  methods: {
    getUser() {
      let that = this;
      that.$api.get(
          "/api/index/userdata",
          {},
          res => {
            console.log(res.data);
            this.formData.username = res.data.name;
            this.formData.phone = res.data.phone;
            this.formData = res.data;
          },
          r => {
            // that.$message.error(r.msg);
          }
      );
    },

    // 功能跳转
    toFunc(item) {
      let name = ''
      switch (item.key) {
        case 'sai':
          name = "SaiDateList"
          break;
        case 'huiyi':
          name = "HuiyiList"
          break;
        case 'club':
          name = "ClubIndex"
          break;
        case 'dakejian':
          name = "DakejianList"
          break;
        case 'sihao':
          name = "PageYundongyuandengji"
          break;
        default:
          this.$message.warning("正在建设中哦~")
          // this.centerDialogVisible = true
      }
      if (!name) return
      this.$router.push({
        name: name
      })
    },
    onMineInfoEdit(path) {
      // this.$message.warning("正在建设中哦~")

      // return
      this.$router.push({
        path: path,
        query: {}
      });
    },

  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.func-row-box {
  display: flex;
  justify-content: flex-start;

  .func-row-li {
    margin-right: 48px;
    text-align: center;
    cursor: pointer;

    .func-row-img {
      img {
        width: 48px;
        height: 48px;
      }
    }

    .func-row-tip {
      font-weight: 400;
      color: #333333;
      font-size: 14px;
      margin-top: 10px;
    }

  }
}


.mine-li {
  background: #fff;
  padding: 20px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  margin-bottom: 20px;
}

.eidt-btn {
  font-size: 14px;
  font-weight: 400;
  color: #1890ff;
  margin-left: 13px;
  cursor: pointer;
}

.tishi {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
}

.info-row-desc {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
}

.info-row-title {
  width: 70px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
}

.updatalinfo-row-title {
  height: 25px;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  line-height: 25px;
  margin-bottom: 20px;
}

.mine-box-title {
  height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  line-height: 33px;
  margin-bottom: 13px;
}
</style>



// WEBPACK FOOTER //
// UpdataInfo.vue?249041bc